<template>
  	<div class="main">
  		<div class="left">
  			<goBack></goBack>
	    	<div class="top">
	    		<div class="top-r">
	    			<div class="top-title">{{post.title}}</div>
	    			<div class="top-desc">
	    				<span>作者： {{post.real_name}}</span>
	    				<span>更新：  {{post.updated_at}}</span>
	    				<span>|</span>
	    				<span v-if="!post.is_praised" class="top-btn" title="点赞" @click="praise">赞  {{post.praise_num}}</span>
	    				<span v-else class="top-btn top-is" title="取消赞"  @click="praise">已赞  {{post.praise_num}}</span>
	    				<span v-if="!post.is_collected" class="top-btn" title="收藏" @click="collect">收藏  {{post.collect_num}}</span>
	    				<span v-else class="top-btn top-is" title="取消收藏" @click="collect">已收藏  {{post.collect_num}}</span>
	    				<span>浏览  {{post.pv_num}}</span>
	    				<span>|</span>
	    				<span class="share_style">
	    					分享&nbsp;&nbsp;
							<a @click="shareFn('qzone')" href="javascript:;" class="share_button_qzone" title="分享到QQ空间">
                                <span class="share_txt jtico jtico_qzone"></span>
                            </a>
                            <a @click="shareFn('sina')" href="javascript:;" class="share_button_tsina" title="分享到微博">
                                <span class="share_txt jtico jtico_tsina"></span>
                            </a>
                            <a @click="shareFn('weixin')" href="javascript:;" class="share_button_weixin" title="分享到微信">
                                <span class="share_txt jtico jtico_weixin"></span>
                            </a>
	    				</span>
	    			</div>
	    		</div>
	    		<div v-if="post.real_price != 0" class="top-pay">
	    			<img v-if="post.is_pay == 1" src="/static/img/post_pay_info.png"></img>
	    		</div>
	    	</div>
		    <div class="sel-body">
		    	<div class="text-summary-title">【摘要】</div>
		    	<div class="text-summary" v-html="post.desc"></div>
		    	<div v-if="post.real_price == 0 || post.is_pay == 1" class="text-content" v-html="post.content"></div>
		    	<div v-else class="text-ispay">
	    			<div>付费后查看正文</div>
	    			<div class="ispay_btn" @click="topay">是否付费观看全文</div>
		    	</div>
		    </div>
		    <div class="statement">
		    	特别声明:   本平台对所有原创、转载、分享的内容、陈述、观点判断均保持中立，推送文章仅供读者参考。本平台发布的文章、图片等版权归作者所有，部分转载作品、图片如有作者来源标记有误或未做标记的，请原创作者友情提示并联系平台删除。
		    </div>
	    </div>
	    <div class="right">
	    	<div class="r-sign">
	    		<div class="r-s-title">评论（{{post.comment_num}}）</div>
	    		<div class="comment_wrap">
                    <comment :id="lid" type="column" @changeCommentLength="changeCommentNum"></comment>
                </div>
	    	</div>
	    	<div class="r-sign">
	    		<div class="r-s-title">推荐课程</div>
	    		<div class="course-list">
			    	<div v-if="!courseList.length" class="noList">暂时没有课程</div>
			    	<div v-else v-for="(item , index) in courseList" :key="index"  class="courseing" @click="$router.push({name: 'courseInfo', params: {course_id: item.id}})">
						<img :src="item.cover" class="list-img">
						<div class="course-lists">
							<div class="l-title">{{item.title}}</div>
							<div class="l-name">主讲人：{{item.speaker}}</div>
							<div class="l-time">活动时间：{{item.start_time}}-{{item.end_timehm}}</div>
							<div class="l-btn">
								<!-- <div class="l-type" v-if="item.catagory == '企业法务通'">{{item.catagory}}</div> -->
								<!-- <div class="l-type l-type-fldjt" v-else-if="item.catagory == '法律大讲堂'">{{item.catagory}}</div> -->
								<!-- <div class="l-type l-type-no" v-else>{{item.catagory}}</div> -->
								<div class="l-type">{{item.tag_name}}</div>
								<div v-if="item.issign" class="l-sign">报名中</div>
			        			<div v-else class="l-sign l-over">已结束</div>
							</div>
						</div>
			    	</div>
			    </div>
	    	</div>
	    	<div class="r-sign">
	    		<div class="r-desc">
	    			<div class="r-d-info">扫码弘商小程序二维码，随时关注课程信息，快速报名课程哦</div>
	    			<img src="/static/img/wechat.png" class="r-d-img">
	    		</div>
	    	</div>
	    </div>

	    <Modal
            v-model="qrcodeBox"
            title="分享到微信">
            <div id="qrcode" ref="qrcode" style="text-align: center; width: 130px; margin: 0 auto"></div>
            <div slot="footer"></div>
        </Modal>

        <postPay v-if="show_pay_modal" @close="close_pay" :id='post.id' @paySuccess="getInfo"></postPay>
  	</div>
</template>

<script>
import moment from 'moment';
import comment from '@/components/post/z-comment'
import goBack from '@/components/common/goBack';
import postPay from '@/components/common/postPay';
export default {
  	name: 'LawColumnInfo',
  	data () {
    	return {
      		lid:'',
      		post:{},
            courseList:[],
            qrcodeBox:false,
            show_pay_modal:false
    	}
  	},
  	components: {comment,goBack,postPay},
  	computed:{
	    loginStatus() {
	      return this.$store.state.loginStatus;
	    },
	},
  	created() {
    	this.lid = Number(this.$route.params.law_id);
	},
	mounted(){
		this.getInfo()
		this.getCourse();
	},
	methods:{
		//付费
		topay(){
			if( !this.loginStatus ){
	            this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
	            setTimeout(() => {
	              	this.$message.warning( '请先登录后，再次执行操作！' );
	            }, 200);
	            return;
	        };
	        this.show_pay_modal = true;
		},
		close_pay(){
			this.show_pay_modal = false;
		},
		//获取知识详情
		getInfo(){
			var url = 'lawArticle/getArticleDetail/' + this.lid;
	  		this.$http.get(url).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				// console.log('12',res);
	  				this.post = res.data.data;
	  			}
	  		})
		},
		//获取推荐课程
		getCourse(){
	  		let url = 'wxm/course/index';
	  		let param = {
	  			page:1,
	  			per_page:10
	  		};
	  		this.$http.get(url, {params:param} ).then(res => {
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				var datas = res.data.data.data.slice(0,2);//只去前2条数据，由于排序要求不用分页per_page=3处理。
	  				var timestamp = Date.parse(new Date());
	        		timestamp = timestamp / 1000;
	        		for(var i = 0 ; i <datas.length ; i++){
			          datas[i].start_time = moment(datas[i].start_time * 1000).format("YYYY-MM-DD HH:mm");
			          if (datas[i].end_time > timestamp){
			            datas[i].issign = true;
			          }else{
			            datas[i].issign = false;
			          };
			          datas[i].end_timehm = moment(datas[i].end_time * 1000).format("HH:mm");
			        };
			        this.courseList = datas;
	  			}
	  		})
	  	},
	  	changeCommentNum(obj) {
            this.post.comment_num = obj.total;
        },
        //点赞
        praise(){
	    	if (!this.$store.state.loginStatus) {
	            this.$Message.warning('请先登录后再进行评论！');
	            return false;
	        };
	  		if(this.post.is_praised){
	  			var params = {
	  				type:'cancel_praise',
	  				art_id : this.post.id
	  			}
	  		}else{
	  			var params = {
	  				type:'praise',
	  				art_id : this.post.id
	  			}
	  		};
	  		var url = 'lawArticle/praise';
	  		this.$http.post(url , params).then(res =>{
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				if(this.post.is_praised){
			  			this.post.is_praised = false;
			  			this.post.praise_num -= 1;
			  		}else{
			  			this.post.is_praised = true;
			  			this.post.praise_num += 1;
			  		}
	  			}
	  		})
	  	},
	  	//收藏
	  	collect(){
	  		if (!this.$store.state.loginStatus) {
	            this.$Message.warning('请先登录后再进行评论！');
	            return false;
	        };
	  		if(this.post.is_collected){
	  			var params = {
	  				type:'cancel_collect',
	  				art_id : this.post.id
	  			}
	  		}else{
	  			var params = {
	  				type:'collect',
	  				art_id : this.post.id
	  			}
	  		};
	  		var url = 'lawArticle/collect';
	  		this.$http.post(url , params).then(res =>{
	  			if(res.data.retcode == $conf.RETCODE_OK){
	  				if(this.post.is_collected){
			  			this.post.is_collected = false;
			  			this.post.collect_num -= 1;
			  		}else{
			  			this.post.is_collected = true;
			  			this.post.collect_num += 1;
			  		}
	  			}
	  		})
	  	},
	  	//分享
	  	shareFn(name) {
            switch(name) {
                case 'qzone':
                    window.open('//sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + window.location.href + '&title=' + this.post.title + '&summary=' + this.post.summary + '&site=' + this.post.title);
                    break;
                case 'sina':
                    window.open('//service.weibo.com/share/share.php?url=' + window.location.href + '&title=' + this.post.title + '&summary=' + this.post.summary + '&site=' + this.post.title);
                    break;
                case 'weixin':
                    this.qrcodeBox = true
                    break;
            }
        },
	},
	watch:{
		$route(to,from){
		    this.lid = to.params.law_id;
		    this.getInfo();
			this.getCourse();
		},
		loginStatus:{
			deep: true,
		    handler(v, ov) {
		        if(v && !ov){
		        	this.getInfo();
		        };
		    }
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	padding:60px 15%;
	display:flex;
	.left
		width:900px;
		min-height 700px
		margin-right:40px;
		position :relative;
		margin-bottom:50px;
		.back
			display:flex;
			align-items:center;
			font-size:18px;
			color:#686F84;
			cursor: pointer;
			width:70px;
			margin-bottom:20px;
			img
				margin-right:10px;
		.top
			display:flex;
			position: relative;
			padding-right:30px;
			.top-pay
				position: absolute;
				right:-25px;
				top:-10px;
			.top-r
				.top-title
					// height:42px;
					font-size:30px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:42px;
				.top-desc
					height:20px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,0.4);
					line-height:20px;
					margin-top:10px;
					display:flex;
					.top-btn
						cursor:pointer;
					.top-is
						color:#FFCB3F;
					span
						margin-right:25px;
					.share_style
						display: flex;
						align-items: center;
						.jtico
							display: block;
							width: 16px;
							height: 16px;
							margin-right: 4px;
							background: url(/static/img/share_ico.png) no-repeat left;
						.jtico_qzone
							background-position: 0px -64px;
						.jtico_tsina
							background-position: 0px -96px;
						.jtico_weixin
							background-position: 0px -1809px;
		.sel-body
			margin:42px 0px;
			.text-summary-title
				height:22px;
				font-size:16px;
				font-weight:500;
				color:rgba(7,19,54,1);
				line-height:22px;
			.text-summary
				// height:30px;
				margin:10px 0 0 10px;
				font-size:16px;
				font-weight:400;
				color:rgba(7,19,54,1);
				line-height:30px;
				white-space: pre-line;
				word-break: break-word;
				word-wrap: break-word;
				padding-bottom:20px;
				border-bottom:1px solid rgba(241,241,241,1);
			.text-content
				margin-top:27px;
				min-height:400px;
				// height:500px;
				// overflow:hidden;
			.text-ispay
				display:flex;
				flex-direction:column;
				align-items:center;
				margin-top:50px;
				min-height:400px;
				font-size:16px;
				color:#071336;
				.ispay_btn
					text-align:center;
					cursor:pointer;
					width:238px;
					height:36px;
					line-height:36px;
					background:#2751CB;
					border:1px solid #2751CB;
					border-radius:22px;
					margin-top:16px;
					color:#fff;
		.statement
			border-top:1px solid rgba(241,241,241,1);
			padding-top:37px;
			// position :absolute;
			// bottom :0;
			// left: 0;
			// width:870px;
			height:48px;
			font-size:14px;
			font-weight:400;
			color:rgba(7,19,54,0.4);
			line-height:24px;
	.right
		width:400px;
		.r-sign
			margin-left:30px;
			margin-top:30px;
			.r-s-title
				height:28px;
				font-size:20px;
				font-weight:500;
				color:rgba(7,19,54,1);
				line-height:28px;
			.comment_wrap
				max-height: 500px;
				overflow :auto;
				padding: 0 15px 25px;
			.course-list
				margin-top:10px;
				display:flex;
				flex-wrap: wrap;
				// width:1374px;
				// height:450px;
				.courseing
					box-shadow:0px 2px 27px 0px rgba(0,84,116,0.11);
					width: 348px;
					height: 150px;
					border-radius: 10px;
					margin: 10px 5px;
					display:flex;
					position: relative;
					cursor:pointer;
				  	.list-img
						width: 348px;
						height: 150px;
						border-radius: 10px;
				  	.course-lists
						margin-right: 24px;
						position: absolute;
						left: 115px;
						top:30px;
						.l-title
							height:42px;
							font-size:15px;
							font-weight:500;
							color:rgba(7,19,54,1);
							line-height:21px;
							overflow: hidden;
							display: -webkit-box;
							text-overflow:ellipsis;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
						.l-name
							height:16px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:16px;
							margin-top:7px;
						.l-time
							height:16px;
							font-size:12px;
							font-weight:400;
							color:rgba(7,19,54,0.6);
							line-height:16px;
							margin-top:2px;
						.l-btn
							display: flex;
							margin-top:6px;
							font-size:10px;
							font-weight:500;
							.l-type
								// width:71px;
								padding:0 10px;
								height:20px;
								line-height:20px;
								background:rgba(209,173,10,1);
								border-radius:10px;
								color: #ffffff;
								text-align: center;
								margin-right:6px;
		  					.l-type-fldjt
								background-color: #5C607D;
		  					.l-type-no
								background-color: #A3AB5F;
		  					.l-sign
								width:50px;
								height:20px;
								line-height:20px;
								background:rgba(33,177,104,1);
								border-radius:10px;
								color: #ffffff;
								text-align: center;
		  					.l-over
								background:rgba(185,185,185,1);
			.r-desc
				display:flex;
				align-items:center;
				justify-content:center;
				width:348px;
				height:114px;
				background:rgba(250,250,250,1);
				border-radius:12px;
				.r-d-img
					width:79px;
					height:79px;
					margin-left:9px;
				.r-d-info
					width:200px;
					height:78px;
					font-size:16px;
					font-weight:400;
					color:rgba(7,19,54,0.8);
					line-height:26px;
</style>
<style lang="stylus">

</style>


// WEBPACK FOOTER //
// src/components/common/lawColumnInfo.vue